<template>
  <div class="tx-dealersearch module-dealersearch-filter">
    <div class="filter__label">
      <span>{{ $t('dealersearch.filter.label') }}</span>
    </div>
    <div class="filter__items">
      <FilterCategory
        v-for="(category) in categories"
        :category="category"
        :key="category.uid"
        @addFilter="addToFilters(category.uid)"
        @removeFilter="removeFromFilters(category.uid)"
      />
    </div>
   </div>
</template>

<script>
import FilterCategory from '@/components/FilterCategory'
import { mapState } from 'vuex'

export default {
  name: 'DealersearchFilter',
  components: { FilterCategory },
  computed: {
    ...mapState({
      categories: state => state.attribute.categories
    })
  },
  methods: {
    addToFilters (categoryUid) {
      this.$store.commit('attribute/addFilterCategory', categoryUid)
      this.$emit('triggerFilter')
    },
    removeFromFilters (categoryUid) {
      this.$store.commit('attribute/removeFilterCategory', categoryUid)
      this.$emit('triggerFilter')
    }
  }
}
</script>
